/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import { CloseRounded, GroupRounded, Refresh } from '@mui/icons-material';
import { useEffect, useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import _ from 'lodash';

import {
  getEbookByMeetingIdRequest,
  ReuniaoComMesAno,
} from '../../../../services/requests';
import { createLogRequest } from '../../../../services/requests/app-logs/utils';

import {
  CardMeeting,
  Div,
  Content,
  Status,
  Typography,
  Li,
  ListUsers,
  Guest,
  Recurrence,
} from './styles';

import { DialogContentStyles } from '../MeetingMinutes/styles';

import { getTypeStatus } from '../../../../utils/meetingHelpers';
import { getCurrentTimezone } from '../../../../utils/dateHelpers';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';

import WaterMark from '../../../../components/WaterMark';
import { splitName } from '../../../../utils/nameHelpers';
import PdfViewer from '../../../../components/ViewerFile/Viewer';
import { verifyUserWhiteList } from '../../../../utils/verifyUserWhiteList';

dayjs().format();

interface MeetingCardProps {
  meeting: ReuniaoComMesAno;
  isPast?: boolean;
}

export const MeetingCard = ({ meeting, isPast = false }: MeetingCardProps) => {
  const navigate = useNavigate();

  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [openPdfViewerModal, setOpenPdfViewerModal] = useState(false);
  const [loadingEbook, setLoadingEbook] = useState(true);
  const [recurrencePosition, setRecurrencePosition] = useState(0);
  const [fileUrl, setFileUrl] = useState('');

  const meetingGuestsWithoutOwnUserLength: number = meeting.guests_ids?.slice(3)
    .length as number;
  const meetingGuestsWithOwnUserLength: number = meeting.guests_ids?.slice(4)
    .length as number;
  const meetingGuestsWithOwnUser = meeting.guests?.slice(4).map(g => g.name);
  const meetingGuestsWithoutOwnUser = meeting.guests?.slice(3).map(g => g.name);
  const orderedRecurrence = _.orderBy(meeting.recurrence_meetings, 'start_at');
  const userOnCompany = selectedCompany?.users?.some(u => u.id === user?.id);
  const userOnWhiteList = !!verifyUserWhiteList(user?.email as string);

  useEffect(() => {
    orderedRecurrence?.map((m, i) => {
      if (m.id === meeting.id) {
        return setRecurrencePosition(i + 1);
      }
      return 0;
    });
  }, [meeting]);

  const handleGetFilesByMeeting = async (id: string, event: MouseEvent) => {
    event.stopPropagation();

    setLoadingEbook(true);
    setOpenPdfViewerModal(true);

    try {
      const response = await getEbookByMeetingIdRequest(
        id,
        user?.id as string,
        'true',
      );

      if (response?.status === 200) {
        setFileUrl(response?.data);

        if (!userOnWhiteList) {
          await createLogRequest({
            name: user?.name as string,
            user_id: user?.id as string,
            company_id: selectedCompany?.id as string,
            local: 'Reuniões',
            action: 'Visualizou',
            description: `Visualizou o e-book da reunião ${meeting?.title}`,
          });
        }
      }
    } catch (err) {
      console.log('Error handleGetFilesByMeeting => ', err);
    } finally {
      setLoadingEbook(false);
    }
  };

  const handleMeetingById = (id: string, event: MouseEvent) => {
    event.stopPropagation();

    navigate(`detalhes-reuniao/${id}`);
  };

  const handleCloseModal = () => {
    setOpenPdfViewerModal(false);
    setFileUrl('');
  };

  return (
    <CardMeeting
      key={meeting?.id}
      status={meeting?.canceled_at}
      sx={{
        background: meeting?.canceled_at ? '#FFD9DA' : '#ffffff',
      }}
    >
      <Div onClick={event => handleMeetingById(meeting?.id as string, event)}>
        <ul className="date-meeting">
          <Li
            className="day-meeting"
            sx={{ color: meeting?.canceled_at ? '#D01317' : '#12094d' }}
          >
            {dayjs(meeting?.start_at || new Date()).format('DD')}
          </Li>
          <li className="month-meeting">
            {dayjs(meeting?.start_at || new Date()).format('MMMM')}
          </li>
          <Li
            className="duration-meeting"
            sx={{ color: meeting?.canceled_at ? '#D01317' : '#12094d' }}
          >
            {`${dayjs(meeting?.start_at)
              .tz(getCurrentTimezone(), true)
              .format('HH:mm')} - ${dayjs(meeting?.start_at)
              .add(meeting?.duration, 'minutes')
              .tz(getCurrentTimezone(), true)
              .format('HH:mm')}`}
          </Li>
        </ul>
        <Box display="flex" flexDirection="column" gap="5px">
          <Status sx={{ background: getTypeStatus(meeting?.status)?.color }}>
            {getTypeStatus(meeting?.status)?.status}
          </Status>
          <Typography>{meeting?.title}</Typography>
          <ListUsers>
            <GroupRounded
              sx={{ color: 'rgba(0, 0, 0, 0.54)', width: '18px' }}
            />
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="5px"
            >
              <Guest pt="3px">{meeting?.board?.title}</Guest>
            </Box>
            {meeting.guests_ids &&
            meeting.guests_ids.includes(user?.id as string) ? (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="5px"
              >
                <Guest sx={{ fontWeight: '700' }}>{' | '}</Guest>
                <Guest sx={{ fontWeight: '700', pt: '3px' }}>
                  {meeting.guests_ids.length > 1 ? 'Você, ' : 'Você'}
                </Guest>

                <Guest sx={{ pt: '3px' }}>
                  {meeting.guests
                    .filter(g => g.id !== user?.id)
                    .map(g => splitName(g.name, 'firstAndLast'))
                    .slice(0, 3)
                    .join(', ')}
                </Guest>
                {meetingGuestsWithOwnUserLength >= 1 ? (
                  <Tooltip title={meetingGuestsWithOwnUser.join(' | ')}>
                    <Guest sx={{ textDecoration: 'underline', pt: '3px' }}>
                      +{meetingGuestsWithOwnUserLength}{' '}
                      {meetingGuestsWithOwnUserLength > 1
                        ? 'pessoas'
                        : 'pessoa'}
                    </Guest>
                  </Tooltip>
                ) : null}
              </Box>
            ) : (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap="5px"
              >
                <Guest sx={{ fontWeight: '700' }}>{' | '}</Guest>
                <Guest sx={{ pt: '3px' }}>
                  {meeting.guests
                    .map(g => splitName(g.name, 'firstAndLast'))
                    .slice(0, 3)
                    .join(', ')}
                </Guest>
                {meetingGuestsWithoutOwnUserLength >= 1 ? (
                  <Tooltip title={meetingGuestsWithoutOwnUser.join(', ')}>
                    <Guest sx={{ textDecoration: 'underline' }}>
                      +{meetingGuestsWithoutOwnUserLength}{' '}
                      {meetingGuestsWithoutOwnUserLength > 1
                        ? 'pessoas'
                        : 'pessoa'}
                    </Guest>
                  </Tooltip>
                ) : null}
              </Box>
            )}
          </ListUsers>
          {meeting.recurrence_meetings &&
          meeting?.recurrence_meetings?.length > 1 ? (
            <Recurrence>
              <Refresh />
              {`Recorrência ${recurrencePosition}/${meeting.recurrence_meetings.length}`}
            </Recurrence>
          ) : null}
        </Box>
      </Div>
      <Content>
        {(!isPast ? meeting?.canceled_at === null : !isPast) &&
          meeting?.link_address && (
            <a
              href={meeting?.link_address as string}
              target="_blank"
              rel="noreferrer"
            >
              <Button className="btn-zoom" variant="contained">
                Ingressar
              </Button>
            </a>
          )}
        {meeting?.canceled_at ? (
          ''
        ) : (userOnCompany || userOnWhiteList) &&
          meeting?.ebookFilesCount > 0 ? (
          <Button
            className="btn-meeting"
            variant="outlined"
            onClick={event =>
              handleGetFilesByMeeting(meeting?.id as string, event)
            }
          >
            Ebook da Reunião
          </Button>
        ) : null}
      </Content>

      <Dialog
        open={openPdfViewerModal}
        fullWidth
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{
          width: '100%',
          height: '100%',
        }}
        PaperProps={{
          sx: {
            height: '100%',
            width: '100%',
            maxHeight: 'none',
            maxWidth: 'none',
            margin: '0',
            backgroundColor: '#5f5f5f',
            borderRadius: '0px',
            // backgroundColor: '#1a1a1a',
          },
        }}
      >
        <Box width="100%" height="100%">
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '5px 10px',
              backgroundColor: 'rgb(238, 238, 238)',
              position: 'fixed',
              height: '52px',
              margin: '0px',
              zIndex: '10',
              width: '100%',
            }}
          >
            <Typography
              sx={{
                color: '#000000',
                fontFamily: 'Roboto',
                fontWeight: '500',
                fontSize: '19px',
                lineHeight: '29px',
              }}
            >
              {`Ebook da reunião ${meeting?.title}`}
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseRounded sx={{ fontSize: '25px', color: '#000000' }} />
            </IconButton>
          </DialogTitle>

          <DialogContentStyles
            sx={{ height: 'fit-content', padding: 0, marginTop: '52px' }}
            onContextMenu={e => e.preventDefault()}
          >
            {loadingEbook ? (
              <Box
                width="100%"
                height="100%"
                padding="20px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Box>
            ) : fileUrl ? (
              // <WaterMark
              //   fileUrl={fileUrl}
              //   fileId=""
              //   isEbook
              //   fileName={`E-book da ${meeting?.title}`}
              // />
              <PdfViewer
                fileUrl={fileUrl}
                fileId=""
                isEbook
                fileName={
                  `E-book da Reunião ${meeting?.title}` || 'E-book da Reunião'
                }
              />
            ) : (
              'Nenhum documento adicionado a reunião'
            )}
          </DialogContentStyles>
        </Box>
      </Dialog>
    </CardMeeting>
  );
};
